import React from 'react'
import Timer from './Timer'
import './style.scss'

const FlashDealSwimlane = ({
  headerImg,
  ctaTextColor,
  bgColor,
  enableTimerConfiguration,
  timerBgColor,
  timerTextColor,
}) => {
  return (
    <div
      className="flash-deal-swimlane__wrapper"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flash-deal-swimlane__header">
        {headerImg && (
          <div className="flash-deal-swimlane__header-img">
            <img src={headerImg} alt="Header Image" />
          </div>
        )}
        {enableTimerConfiguration && (
          <div className="flash-deal-swimlane__timer">
            <Timer
              time={['14', '10', '02']}
              bgColor={timerBgColor}
              textColor={timerTextColor}
            />
          </div>
        )}
        <div className="flash-deal-swimlane__cta">
          <span style={{ color: ctaTextColor }}>See all</span>
        </div>
      </div>
      <div className="flash-deal-swimlane__product-cards">
        <img src="/images/AppHome/ProductCards.webp" alt="Product Cards" />
      </div>
    </div>
  )
}

export default FlashDealSwimlane
